import React from "react";
import {
  Container,
  Typography,
  Button,
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";
import { styled } from "@mui/system";
import restaurantbgWEB from "../assets/restaurantbgWEB.png";
import portfoliobgWEB from "../assets/portfoliobgWEB.jpeg";
import ecommercebgWEB from "../assets/ecommercebgWEB.jpg";

// Page Wrapper with White Background
const Section = styled("section")({
  background: "#FFFFFF",
  minHeight: "115vh",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "60px 20px",
  position: "relative",
});

// Gradient Container (Moved Up)
const GradientContainer = styled(Container)({
  background: "linear-gradient(to right, #00c9a7, #0072ff)",
  padding: "40px",
  borderRadius: "20px",
  boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.2)",
  maxWidth: "800px",
  textAlign: "center",
  position: "relative", // Moves container upward
  marginBottom: "55px",
});

const WebDevelopment = () => {
  return (
    <Section>
      {/* UI/UX Design Main Section */}
      <GradientContainer>
        <Typography variant="h2" sx={{ fontWeight: "bold", color: "#FBFFFE" }}>
          Web Devlopment
        </Typography>
        <Typography variant="body1" sx={{ marginTop: 2, color: "#FBFFFE" }}>
          Master web development principles and create visually appealing,
          user-friendly interfaces.
        </Typography>
        <Box sx={{ marginTop: 3 }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#FAA916",
              color: "#FBFFFE",
              "&:hover": { backgroundColor: "#e08c00" },
            }}
          >
            Get Started
          </Button>
        </Box>
      </GradientContainer>

      {/* Recommended Projects Section */}
      <Typography
        variant="h3"
        sx={{ fontWeight: "bold", marginBottom: 4, color: "#333" }}
      >
        Recommended Projects
      </Typography>

      <Grid container spacing={4} justifyContent="center" width="100%">
        {/* Project 1 */}
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: 400,
              width:"420px",
              display: "flex",
              flexDirection: "column",
              borderRadius: 3,
              boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
              transition: "transform 0.3s ease-in-out",
              "&:hover": { transform: "scale(1.05)" },
            }}
          >
            <CardMedia
              component="img"
              height="230"
              image={restaurantbgWEB}
              alt="Online Restaurant Ordering System"
            />
            <CardContent  sx={{ flexGrow: 1 }}>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                Online Restaurant Ordering System
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 1, color: "#555" }}
              >
                A full-stack web app for placing food orders via QR code, with
                real-time admin panel for restaurants.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Project 2 */}
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: 400,
              width:"420px",
              display: "flex",
              flexDirection: "column",
              borderRadius: 3,
              boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
              transition: "transform 0.3s ease-in-out",
              "&:hover": { transform: "scale(1.05)" },
            }}
          >
            <CardMedia
              component="img"
              height="230"
              image={ecommercebgWEB}
              alt="Online Restaurant Ordering System"
            />
            <CardContent  sx={{ flexGrow: 1 }}>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                E-commerce Platform with Node.js
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 1, color: "#555" }}
              >
                A sleek and minimal mobile app design for smooth UX.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Project 3 */}
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: 400,
              width:"420px",
              display: "flex",
              flexDirection: "column",
              borderRadius: 3,
              boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
              transition: "transform 0.3s ease-in-out",
              "&:hover": { transform: "scale(1.05)" },
            }}
          >
            <CardMedia
              component="img"
              height="230"
              image={portfoliobgWEB}
              alt="Online Restaurant Ordering System"
            />
            <CardContent  sx={{ flexGrow: 1 }}>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                Developer Portfolio with CMS
              </Typography>
              <Typography variant="body2" color="text.secondary">
                A user-friendly UI design for seamless online shopping.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Section>
  );
};

export default WebDevelopment;
